import { ButtonAction, ButtonType } from '../../action-button';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../confirmation-dialog.component';
import { ConfirmationDialogActions } from '../constants/confirmation-dialog-actions.constant';

export interface ConfirmationDialogDataModel {
  id: ConfirmationDialogActions;
  title?: string;
  mainText?: string;
  highlightedText?: string;
  additionalTextBlock?: string | null;
  buttonAction?: ButtonAction;
  buttonType?: ButtonType;
}

export interface ConfirmationDialogAfterClosedModel {
  dialogRef: MatDialogRef<ConfirmationDialogComponent>;
}
